import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";

@customElement("ds-close-button")
export class CloseButton extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: inline-block;
            }

            sl-icon-button {
                background-color: var(--ds-accent-color);
                border: 3px solid white;
                border-radius: 50%;
                opacity: 0.8;
                font-size: 1.5em;
                color: white;
            }
        `,
    ];

    override render() {
        return html`
            <sl-icon-button
                class="close-button"
                name="x-lg"
                @click=${() => this._raiseEvent("ds-close")}
            ></sl-icon-button>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-close-button": CloseButton;
    }
}
